import { searchValues } from "../utils/options";
import { booleanOptions, Input, MultiSearchForm, useDebouncedSearch } from "@";

const MultiSearch = ({ onSubmit, search, updateSearch }) => {
  useDebouncedSearch(onSubmit, search.values, searchValues);

  const handleInputChange = (field, value) => {
    updateSearch({
      values: { ...search.values, [field]: value },
    });
  };

  return (
    <MultiSearchForm
      show={search.show}
      onSubmit={onSubmit}
      className="multi-search-form xl:grid-cols-5"
      reset={() => updateSearch({ values: searchValues })}
    >
      <>
        {/* Input for keyword search */}
        <Input
          star
          label="كلمة البحث"
          value={search.values.title}
          change={(e) => handleInputChange("title", e.target.value)}
        />

        {/* Input for date range */}
        <Input
          star
          showTimeSelect
          type="date-range"
          labelA="من تاريخ"
          labelB="الي تاريخ"
          style="lg:col-span-2"
          valueB={search.values.toDate}
          valueA={search.values.fromDate}
          changeB={(e) => handleInputChange("toDate", e)}
          changeA={(e) => handleInputChange("fromDate", e)}
        />

        {/* Input for number range */}
        <Input
          star
          type="number-range"
          labelA="المبلغ من"
          labelB="المبلغ الي"
          valueA={search.values.fromAmount}
          valueB={search.values.toAmount}
          changeB={(e) => handleInputChange("toAmount", e.target.value)}
          changeA={(e) => handleInputChange("fromAmount", e.target.value)}
        />

        {/* Additional search options */}
        {[
          { field: "isActive", label: "نشط" },
          { field: "isArchived", label: "مؤرشف" },
          { field: "isCompleted", label: "مكتمل" },
          { field: "showInHomePage", label: "عرض في الصفحة الرئيسية" },
        ].map(({ field, label }) => (
          <Input
            star
            key={field}
            label={label}
            type="select"
            list={booleanOptions}
            value={search.values[field]}
            change={(e) => handleInputChange(field, e.target.value)}
          />
        ))}
      </>
    </MultiSearchForm>
  );
};

export default MultiSearch;
